const LOAD = 'server-sts/equipsnSync/LOAD';
const LOAD_SUCCESS = 'server-sts/equipsnSync/LOAD_SUCCESS';
const LOAD_FAIL = 'server-sts/equipsnSync/LOAD_FAIL';

const STATS = 'server-sts/equipsnSync/STATS';
const STATS_SUCCESS = 'server-sts/equipsnSync/STATS_SUCCESS';
const STATS_FAIL = 'server-sts/equipsnSync/STATS_FAIL';

const RESYNC = 'server-sts/equipsnSync/RESYNC';
const RESYNC_SUCCESS = 'server-sts/equipsnSync/RESYNC_SUCCESS';
const RESYNC_FAIL = 'server-sts/equipsnSync/RESYNC_FAIL';

const UPDATE_MANUAL = 'server-sts/equipsnSync/UPDATE_MANUAL';
const UPDATE_MANUAL_SUCCESS = 'server-sts/equipsnSync/UPDATE_MANUAL_SUCCESS';
const UPDATE_MANUAL_FAIL = 'server-sts/equipsnSync/UPDATE_MANUAL_FAIL';

const RESOLVE = 'server-sts/equipsnSync/RESOLVE';
const RESOLVE_SUCCESS = 'server-sts/equipsnSync/RESOLVE_SUCCESS';
const RESOLVE_FAIL = 'server-sts/equipsnSync/RESOLVE_FAIL';

const HISTORY = 'server-sts/equipsnSync/HISTORY';
const HISTORY_SUCCESS = 'server-sts/equipsnSync/HISTORY_SUCCESS';
const HISTORY_FAIL = 'server-sts/equipsnSync/HISTORY_FAIL';

const RESYNC_ONE = 'server-sts/equipsnSync/RESYNC_ONE';
const RESYNC_ONE_SUCCESS = 'server-sts/equipsnSync/RESYNC_ONE_SUCCESS';
const RESYNC_ONE_FAIL = 'server-sts/equipsnSync/RESYNC_ONE_FAIL';

const EXPORT_CSV = 'server-sts/equipsnSync/EXPORT_CSV';
const EXPORT_CSV_SUCCESS = 'server-sts/equipsnSync/EXPORT_CSV_SUCCESS';
const EXPORT_CSV_FAIL = 'server-sts/equipsnSync/EXPORT_CSV_FAIL';

const CLEAN_ORPHANS = 'server-sts/equipsnSync/CLEAN_ORPHANS';
const CLEAN_ORPHANS_SUCCESS = 'server-sts/equipsnSync/CLEAN_ORPHANS_SUCCESS';
const CLEAN_ORPHANS_FAIL = 'server-sts/equipsnSync/CLEAN_ORPHANS_FAIL';

const AUTHORIZE = 'server-sts/equipsnSync/AUTHORIZE';
const AUTHORIZE_SUCCESS = 'server-sts/equipsnSync/AUTHORIZE_SUCCESS';
const AUTHORIZE_FAIL = 'server-sts/equipsnSync/AUTHORIZE_FAIL';
const AUTHORIZATIONS = 'server-sts/equipsnSync/AUTHORIZATIONS';
const AUTHORIZATIONS_SUCCESS = 'server-sts/equipsnSync/AUTHORIZATIONS_SUCCESS';
const AUTHORIZATIONS_FAIL = 'server-sts/equipsnSync/AUTHORIZATIONS_FAIL';

const SET_CLIENT_KEY = 'server-sts/equipsnSync/SET_CLIENT_KEY';
const SET_CLIENT_KEY_SUCCESS = 'server-sts/equipsnSync/SET_CLIENT_KEY_SUCCESS';
const SET_CLIENT_KEY_FAIL = 'server-sts/equipsnSync/SET_CLIENT_KEY_FAIL';
const REVOKE_CLIENT_KEY = 'server-sts/equipsnSync/REVOKE_CLIENT_KEY';
const REVOKE_CLIENT_KEY_SUCCESS = 'server-sts/equipsnSync/REVOKE_CLIENT_KEY_SUCCESS';
const REVOKE_CLIENT_KEY_FAIL = 'server-sts/equipsnSync/REVOKE_CLIENT_KEY_FAIL';
const CLIENT_KEYS = 'server-sts/equipsnSync/CLIENT_KEYS';
const CLIENT_KEYS_SUCCESS = 'server-sts/equipsnSync/CLIENT_KEYS_SUCCESS';
const CLIENT_KEYS_FAIL = 'server-sts/equipsnSync/CLIENT_KEYS_FAIL';
const EXPORT_TESTLIFT_AUTH = 'server-sts/equipsnSync/EXPORT_TESTLIFT_AUTH';
const EXPORT_TESTLIFT_AUTH_SUCCESS = 'server-sts/equipsnSync/EXPORT_TESTLIFT_AUTH_SUCCESS';
const EXPORT_TESTLIFT_AUTH_FAIL = 'server-sts/equipsnSync/EXPORT_TESTLIFT_AUTH_FAIL';
const FETCH_ASM_KEYS = 'server-sts/equipsnSync/FETCH_ASM_KEYS';
const FETCH_ASM_KEYS_SUCCESS = 'server-sts/equipsnSync/FETCH_ASM_KEYS_SUCCESS';
const FETCH_ASM_KEYS_FAIL = 'server-sts/equipsnSync/FETCH_ASM_KEYS_FAIL';
const PUSH_SCOPE_NOW = 'server-sts/equipsnSync/PUSH_SCOPE_NOW';
const PUSH_SCOPE_NOW_SUCCESS = 'server-sts/equipsnSync/PUSH_SCOPE_NOW_SUCCESS';
const PUSH_SCOPE_NOW_FAIL = 'server-sts/equipsnSync/PUSH_SCOPE_NOW_FAIL';

const initialState = {
  clientKeyLoading: false,
  clientKeyError: null,
  clientKeyResult: null,
  clientKeysLoading: false,
  clientKeysError: null,
  clientKeys: [],
  exportAuthLoading: false,
  exportAuthError: null,
  fetchAsmKeysLoading: false,
  fetchAsmKeysError: null,
  fetchAsmKeysResult: null,
  pushScopeLoading: false,
  pushScopeError: null,
  authorizationLoading: false,
  authorizationError: null,
  authorizationsLoading: false,
  authorizationsError: null,
  authorizations: [],
  authorizationsTotal: 0,
  data: [],
  total: 0,
  loading: false,
  error: null,
  stats: null,
  statsLoading: false,
  statsError: null,
  resyncLoading: false,
  resyncResult: null,
  resyncError: null,
  updateLoading: false,
  updateError: null,
  resolveLoading: false,
  resolveResult: null,
  resolveError: null,
  historyLoading: false,
  historyRows: [],
  historyError: null,
  resyncOneLoading: false,
  resyncOneError: null,
  exportLoading: false,
  exportError: null,
  cleanOrphansLoading: false,
  cleanOrphansResult: null,
  cleanOrphansError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return { ...state, loading: true, error: null };
    case LOAD_SUCCESS:
      return { ...state, loading: false, data: action.result.rows, total: action.result.total, error: null };
    case LOAD_FAIL:
      return { ...state, loading: false, error: action.error };

    case STATS:
      return { ...state, statsLoading: true, statsError: null };
    case STATS_SUCCESS:
      return { ...state, statsLoading: false, stats: action.result };
    case STATS_FAIL:
      return { ...state, statsLoading: false, statsError: action.error };

    case RESYNC:
      return { ...state, resyncLoading: true, resyncResult: null, resyncError: null };
    case RESYNC_SUCCESS:
      return { ...state, resyncLoading: false, resyncResult: action.result };
    case RESYNC_FAIL:
      return { ...state, resyncLoading: false, resyncError: action.error };

    case UPDATE_MANUAL:
      return { ...state, updateLoading: true, updateError: null };
    case UPDATE_MANUAL_SUCCESS:
      return { ...state, updateLoading: false };
    case UPDATE_MANUAL_FAIL:
      return { ...state, updateLoading: false, updateError: action.error };

    case RESOLVE:
      return { ...state, resolveLoading: true, resolveResult: null, resolveError: null };
    case RESOLVE_SUCCESS:
      return { ...state, resolveLoading: false, resolveResult: action.result };
    case RESOLVE_FAIL:
      return { ...state, resolveLoading: false, resolveError: action.error };

    case HISTORY:
      return { ...state, historyLoading: true, historyError: null };
    case HISTORY_SUCCESS:
      return { ...state, historyLoading: false, historyRows: action.result.rows };
    case HISTORY_FAIL:
      return { ...state, historyLoading: false, historyError: action.error };

    case RESYNC_ONE:
      return { ...state, resyncOneLoading: true, resyncOneError: null };
    case RESYNC_ONE_SUCCESS:
      return { ...state, resyncOneLoading: false };
    case RESYNC_ONE_FAIL:
      return { ...state, resyncOneLoading: false, resyncOneError: action.error };

    case EXPORT_CSV:
      return { ...state, exportLoading: true, exportError: null };
    case EXPORT_CSV_SUCCESS:
      return { ...state, exportLoading: false };
    case EXPORT_CSV_FAIL:
      return { ...state, exportLoading: false, exportError: action.error };

    case CLEAN_ORPHANS:
      return { ...state, cleanOrphansLoading: true, cleanOrphansResult: null, cleanOrphansError: null };
    case CLEAN_ORPHANS_SUCCESS:
      return { ...state, cleanOrphansLoading: false, cleanOrphansResult: action.result };
    case CLEAN_ORPHANS_FAIL:
      return { ...state, cleanOrphansLoading: false, cleanOrphansError: action.error };

    case AUTHORIZE:
      return { ...state, authorizationLoading: true, authorizationError: null };
    case AUTHORIZE_SUCCESS:
      return { ...state, authorizationLoading: false };
    case AUTHORIZE_FAIL:
      return { ...state, authorizationLoading: false, authorizationError: action.error };
    case AUTHORIZATIONS:
      return { ...state, authorizationsLoading: true, authorizationsError: null };
    case AUTHORIZATIONS_SUCCESS:
      return { ...state, authorizationsLoading: false, authorizations: action.result.rows, authorizationsTotal: action.result.total };
    case AUTHORIZATIONS_FAIL:
      return { ...state, authorizationsLoading: false, authorizationsError: action.error };

    case SET_CLIENT_KEY:
      return { ...state, clientKeyLoading: true, clientKeyError: null, clientKeyResult: null };
    case SET_CLIENT_KEY_SUCCESS:
      return { ...state, clientKeyLoading: false, clientKeyResult: action.result };
    case SET_CLIENT_KEY_FAIL:
      return { ...state, clientKeyLoading: false, clientKeyError: action.error };

    case REVOKE_CLIENT_KEY:
      return { ...state, clientKeyLoading: true, clientKeyError: null };
    case REVOKE_CLIENT_KEY_SUCCESS:
      return { ...state, clientKeyLoading: false, clientKeyResult: null };
    case REVOKE_CLIENT_KEY_FAIL:
      return { ...state, clientKeyLoading: false, clientKeyError: action.error };

    case CLIENT_KEYS:
      return { ...state, clientKeysLoading: true, clientKeysError: null };
    case CLIENT_KEYS_SUCCESS:
      return { ...state, clientKeysLoading: false, clientKeys: action.result.rows };
    case CLIENT_KEYS_FAIL:
      return { ...state, clientKeysLoading: false, clientKeysError: action.error };

    case EXPORT_TESTLIFT_AUTH:
      return { ...state, exportAuthLoading: true, exportAuthError: null };
    case EXPORT_TESTLIFT_AUTH_SUCCESS:
      return { ...state, exportAuthLoading: false };
    case EXPORT_TESTLIFT_AUTH_FAIL:
      return { ...state, exportAuthLoading: false, exportAuthError: action.error };

    case FETCH_ASM_KEYS:
      return { ...state, fetchAsmKeysLoading: true, fetchAsmKeysError: null, fetchAsmKeysResult: null };
    case FETCH_ASM_KEYS_SUCCESS:
      return { ...state, fetchAsmKeysLoading: false, fetchAsmKeysResult: action.result };
    case FETCH_ASM_KEYS_FAIL:
      return { ...state, fetchAsmKeysLoading: false, fetchAsmKeysError: action.error };

    case PUSH_SCOPE_NOW:
      return { ...state, pushScopeLoading: true, pushScopeError: null };
    case PUSH_SCOPE_NOW_SUCCESS:
      return { ...state, pushScopeLoading: false };
    case PUSH_SCOPE_NOW_FAIL:
      return { ...state, pushScopeLoading: false, pushScopeError: action.error };

    default:
      return state;
  }
}

export function load(params) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.post('/equipsnSync/load', { data: { params } })
  };
}

export function loadStats() {
  return {
    types: [STATS, STATS_SUCCESS, STATS_FAIL],
    promise: (client) => client.post('/equipsnSync/stats', { data: {} })
  };
}

export function resync() {
  return {
    types: [RESYNC, RESYNC_SUCCESS, RESYNC_FAIL],
    promise: (client) => client.post('/equipsnSync/resync', { data: {} })
  };
}

export function updateManual(id, objectIdManual) {
  return {
    types: [UPDATE_MANUAL, UPDATE_MANUAL_SUCCESS, UPDATE_MANUAL_FAIL],
    promise: (client) => client.post('/equipsnSync/updateManual', { data: { id, objectIdManual } })
  };
}

export function resolve(serial, account) {
  return {
    types: [RESOLVE, RESOLVE_SUCCESS, RESOLVE_FAIL],
    promise: (client) => client.post('/equipsnSync/resolve', { data: { serial, account } })
  };
}

export function loadHistory(id) {
  return {
    types: [HISTORY, HISTORY_SUCCESS, HISTORY_FAIL],
    promise: (client) => client.post('/equipsnSync/history', { data: { params: { id } } })
  };
}

export function resyncOne(id) {
  return {
    types: [RESYNC_ONE, RESYNC_ONE_SUCCESS, RESYNC_ONE_FAIL],
    promise: (client) => client.post('/equipsnSync/resyncOne', { data: { id } })
  };
}

export function exportCsv() {
  return {
    types: [EXPORT_CSV, EXPORT_CSV_SUCCESS, EXPORT_CSV_FAIL],
    promise: (client) => client.post('/equipsnSync/exportCsv', { data: {} })
  };
}

export function setTestLiftAuthorization(data) {
  return {
    types: [AUTHORIZE, AUTHORIZE_SUCCESS, AUTHORIZE_FAIL],
    promise: client => client.post('/equipsnSync/setTestLiftAuthorization', { data })
  };
}

export function loadTestLiftAuthorizations(params) {
  return {
    types: [AUTHORIZATIONS, AUTHORIZATIONS_SUCCESS, AUTHORIZATIONS_FAIL],
    promise: client => client.post('/equipsnSync/listTestLiftAuthorizations', { data: { params } })
  };
}

export function cleanOrphans(id) {
  return {
    types: [CLEAN_ORPHANS, CLEAN_ORPHANS_SUCCESS, CLEAN_ORPHANS_FAIL],
    promise: (client) => client.post('/equipsnSync/cleanOrphans', { data: { id } })
  };
}

export function setClientKey(clientId, keyType, key) {
  return {
    types: [SET_CLIENT_KEY, SET_CLIENT_KEY_SUCCESS, SET_CLIENT_KEY_FAIL],
    promise: (client) => client.post('/equipsnSync/setClientKey', { data: { clientId, keyType, key } })
  };
}

export function revokeClientKey(clientId, keyType) {
  return {
    types: [REVOKE_CLIENT_KEY, REVOKE_CLIENT_KEY_SUCCESS, REVOKE_CLIENT_KEY_FAIL],
    promise: (client) => client.post('/equipsnSync/revokeClientKey', { data: { clientId, keyType } })
  };
}

export function loadClientKeys() {
  return {
    types: [CLIENT_KEYS, CLIENT_KEYS_SUCCESS, CLIENT_KEYS_FAIL],
    promise: (client) => client.post('/equipsnSync/listClientKeys', { data: {} })
  };
}

export function exportTestLiftAuthorizations() {
  return {
    types: [EXPORT_TESTLIFT_AUTH, EXPORT_TESTLIFT_AUTH_SUCCESS, EXPORT_TESTLIFT_AUTH_FAIL],
    promise: (client) => client.post('/equipsnSync/exportTestLiftAuthorizations', { data: {} })
  };
}

export function fetchAsmKeys(clientId) {
  return {
    types: [FETCH_ASM_KEYS, FETCH_ASM_KEYS_SUCCESS, FETCH_ASM_KEYS_FAIL],
    promise: (client) => client.post('/equipsnSync/fetchAsmKeys', { data: { clientId } })
  };
}

export function pushScopeNow(clientId) {
  return {
    types: [PUSH_SCOPE_NOW, PUSH_SCOPE_NOW_SUCCESS, PUSH_SCOPE_NOW_FAIL],
    promise: (client) => client.post('/equipsnSync/pushScopeNow', { data: { clientId } })
  };
}
